import { RWA_COLORS } from "~/styles/colors";
import { ColumnPlotOptions } from "./components/Timeseries/types";
import { hexToRGB } from "~/utils/hexToRGB";

// // // //

export const DEFAULT_TOOLTIP_PROPS = {
    borderRadius: 4,
    borderWidth: 1,
    borderColor: "var(--border)",
    shadow: false,
};

// Define standard color for grid lines on x + y axes
const gridLineColor = hexToRGB(RWA_COLORS.slate["400"], 0.8);

export const DEFAULT_AXIS_PROPS = {
    gridLineWidth: 1, // Set the width of the vertical grid lines
    gridLineColor: gridLineColor, // Set the color of grid lines
    gridLineDashStyle: "Dash", // Set the dash style of the vertical grid lines
    tickColor: gridLineColor, // Color of the tick marks
    lineWidth: 1, // Width of the axis line
    lineColor: RWA_COLORS.slate["300"], // Color the axis line
    title: {
        text: null,
    },
};

export const DEFAULT_AXIS_LABEL_PROPS = {
    style: {
        color: RWA_COLORS.slate["400"],
        fontSize: ".9rem",
    },
};

export const DEFAULT_COLUMN_PLOT_OPTIONS: ColumnPlotOptions = {
    stacking: "normal",
    pointPadding: 0,
    groupPadding: 0,
    borderRadius: 0,
};
